import { createElement } from 'react';

/**
 * @constant
 * @type {{ [k in HeadlineTag]: number }}
 */
export const HeadlineLevel = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
  h5: 5,
  h6: 6,
};

/**
 * Headline component renders a heading element with the specified level.
 *
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Content of the headline
 * @param {string | undefined} [props.className] - Additional CSS classes
 * @param {typeof HeadlineLevel[keyof typeof HeadlineLevel]} props.level - Heading level
 * @returns {React.ReactElement} The rendered headline element
 */
const Headline = ({ children, className, level }) => {
  const tag = `h${level}`;
  return createElement(tag, { className }, children);
};

export default Headline;
